import { render } from "./SkillsView.vue?vue&type=template&id=4d09e3e6&scoped=true"
import script from "./SkillsView.vue?vue&type=script&lang=js"
export * from "./SkillsView.vue?vue&type=script&lang=js"

import "./SkillsView.vue?vue&type=style&index=0&id=4d09e3e6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3459830904/src/personalwebsite2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d09e3e6"]])

export default __exports__